import React from "react";
import Passkey from '../../assets/images/passkey.svg';
import CCR_Logo_New from '../../assets/images/CCR_Logo_New.svg';
import { TextField, Typography } from "@material-ui/core";
import CCRCommonHeader from "../common/CCRCommonHeader";
import { useStyles } from "./CCRStyles";
import { AppType } from "../../constant/appType";

function CCRSignInForm(props) {
    const ccrStyles = useStyles();

    function onEnter(e) {
        props.signIn();
        e.preventDefault();
    }

    return (
        <CCRCommonHeader customTemplate={props.customTemplate} header="Log In" headerIcon={Passkey} appType={props.appConfig.appType}>
            <div style={{ padding: '10px 0px 40px' }}>
                <div style={{ fontSize: '14px', textAlign: 'center', marginBottom: '10px' }}>
                    CCR Employees exclusive access
                </div>
                <div style={{ background: '#102F4E', height: '25px', width: '300px', borderRadius: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={props.CompanySignIn}>
                    <img src={CCR_Logo_New} alt="CCR_LOGO" /> <span style={{ padding: '2px 0px 0px 4px', color: 'white', fontWeight: 'bold' }}>SSO</span>
                </div>
            </div>
            {props.appConfig.isInternalLoginOnly === 'false'
                ? <>
                    <div style={{ padding: '10px 0px 10px' }}>
                        <div style={{ fontSize: '14px', textAlign: 'center', marginBottom: '10px' }}>
                            External User access
                        </div>
                        <div style={{ width: '365px' }}>
                            <Typography variant="caption">Email Address</Typography>
                            <TextField
                                fullWidth
                                name="username"
                                variant="standard"
                                placeholder="Enter your email"
                                classes={{ root: ccrStyles.customTextField }}
                                error={(props.signInUnReq && !props.UserNameErrorToDefault)}
                                helperText={(props.signInUnReq && !props.UserNameErrorToDefault)
                                    ? props.signInUnReq
                                    : ''
                                }
                                onChange={props.onChange}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        onEnter(e)
                                    }
                                }}

                            />
                        </div>
                        <div style={{ width: '365px', marginTop: '10px' }}>
                            <Typography variant="caption">Password</Typography>
                            <TextField
                                fullWidth
                                name="password"
                                variant="standard"
                                placeholder="******"
                                classes={{ root: ccrStyles.customTextField }}
                                type="password"
                                error={(props.signInPwdReq && !props.passwordErrorFieldToDefault)}
                                helperText={(props.signInPwdReq && !props.passwordErrorFieldToDefault)
                                    ? props.signInPwdReq
                                    : ''
                                }
                                onChange={props.onChange}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        onEnter(e)
                                    }
                                }}

                            />
                        </div>
                        <div
                            style={{
                                color: '#2196F3',
                                fontSize: '14px',
                                fontStyle: 'normal',
                                fontWeight: '400',
                                lineHeight: '150%',
                                textAlign: 'right',
                                padding: '5px 5px 0px 0px',
                                textDecorationLine: 'underline',
                                textDecorationStyle: "solid",
                                textDecorationSkipInk: "none",
                                textDecorationThickness: "auto",
                                textUnderlineOffset: "auto"
                            }}
                        >
                            <span style={{ cursor: 'pointer', fontSize: '12px' }} onClick={props.ForgotPassword}>Forgot your password ?</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                        <div style={{ background: '#4785FF', height: '25px', width: '300px', borderRadius: '20px', cursor: 'pointer', marginTop: '10px', textAlign: 'center' }} disabled={props.signInStatus.indexOf("wait") !== -1 ? `disabled` : ``} onClick={props.signIn}>
                            <span style={{ color: 'white', fontWeight: 'bold' }}>SIGN IN</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '60px' }}>
                        <div style={{ fontSize: '12px', textAlign: 'center', paddingTop: '10px' }}>
                            {(props.signInError && !props.signinErrorToDefault)
                                ? <span style={{ color: 'red' }}>{props.signInError}</span>
                                : (props.signInStatus && !props.signInStatusToDefault)
                                    ? <span>{props.signInStatus}</span>
                                    : null
                            }
                        </div>
                    </div>

                    {props.appConfig.appType === AppType.CSS
                        ? <div style={{ paddingBottom: '5px', fontSize: '14px' }}>
                            New to Cool Systems Select ? <span style={{ color: '#4785FF', cursor: 'pointer', textDecorationLine: 'underline', paddingLeft: '5px' }} onClick={props.CSSNewUserRegister}>Join now</span>
                        </div>
                        : null
                    }
                </>
                : null

            }
        </CCRCommonHeader>
    );

}

export default CCRSignInForm;
